module.exports = __webpack_public_path__ + "static/media/course_words_ru.d5d00a5b.jpg";